import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { Link } from '@inertiajs/react'
import { PLACEHOLDER_ICONS, LIGHT_LEVEL_ICONS, HUMIDITY_LEVEL_ICONS, EnumIcon } from '@/lib/icons'

interface Photo {
  id: number
  url: string
  thumbnail_url: string
}

interface Location {
  id: number
  name: string
  light_level: string | null
  light_level_pl: string | null
  humidity_level: string | null
  humidity_level_pl: string | null
  temperature_range: string | null
  photo: Photo | null
  plants_count: number
}

interface Props {
  locations: Location[]
}

function LocationsIndex({ locations }: Props) {
  return (
    <AtlasPage>
      <PageTitle title="Miejsca" subtitle="Spis miejsc" />
      <Separator />

      {locations.length > 0 ? (
        <div className="grid grid-cols-1 gap-md sm:grid-cols-2 lg:grid-cols-3">
          {locations.map((location) => (
            <Link
              key={location.id}
              href={`/locations/${location.id}`}
              className="group block border border-frame/30 bg-paper-dark/50 p-sm transition-shadow hover:shadow-hover"
            >
              {location.photo ? (
                <img
                  src={location.photo.thumbnail_url}
                  alt={location.name}
                  className="mb-sm h-36 w-full object-cover"
                />
              ) : (
                <div className="mb-sm flex h-36 w-full items-center justify-center bg-desk/50">
                  <PLACEHOLDER_ICONS.location.icon weight="regular" size={36} className="text-frame/40" />
                </div>
              )}
              <h3 className="font-display text-sm uppercase tracking-wider text-ink group-hover:text-botanical">
                {location.name}
              </h3>
              {location.light_level_pl && (
                <p className="text-xs text-frame mt-xs inline-flex items-center gap-xs">
                  <EnumIcon entry={location.light_level ? LIGHT_LEVEL_ICONS[location.light_level] : undefined} size={14} />
                  {location.light_level_pl}
                </p>
              )}
              {location.humidity_level_pl && (
                <p className="text-xs text-frame/70 mt-xs inline-flex items-center gap-xs">
                  <EnumIcon entry={location.humidity_level ? HUMIDITY_LEVEL_ICONS[location.humidity_level] : undefined} size={14} />
                  {location.humidity_level_pl}
                </p>
              )}
              <p className="text-xs text-ink-light mt-xs font-label">
                {location.plants_count === 0 ? 'Brak roślin' : `${location.plants_count} ${location.plants_count === 1 ? 'roślina' : location.plants_count < 5 ? 'rośliny' : 'roślin'}`}
              </p>
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-xl">
          <p className="text-frame italic font-label">Brak miejsc w kolekcji.</p>
        </div>
      )}

      <Separator />
      <div className="flex justify-center">
        <Button href="/locations/new">Dodaj miejsce</Button>
      </div>

      <PageNumber number={10} />
    </AtlasPage>
  )
}

LocationsIndex.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default LocationsIndex
